import { Col, Modal, Row } from 'antd'
import Button from 'components/Button'
import Flex from 'components/Flex'
import ErrorMessage from 'components/UIComponents/MessagePopup/ErrorMessage'
import { FooterFlex } from 'modules/Drives/DownloadAndUpload/DownloadCandidateDrawer/style'
import React from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import styled from 'styled-components'
import { COLORS } from 'theme'
import SuccessMessage from 'utils/SuccessMessage'
import { downloadAttachment } from 'utils/downloadAttachment'
import { exportCandidate } from '../../../actions'
import { CardText, CardsFlex1 } from './style'
export const FlexWrapRole = styled(Flex)`
  width: ${props => (props.width ? props.width : '100%')};
  gap: ${props => (props.gap ? props.gap : '0')};
`

const mapArray = [
  {
    name: '10th',
    key: 'tenth',
  },
  {
    name: '12th',
    key: 'twelfth',
  },
  {
    name: 'UG',
    key: 'ug',
  },
  {
    name: 'PG',
    key: 'pg',
  },
  {
    name: 'Project',
    key: 'projects',
  },
  {
    name: 'Work Experience',
    key: 'workExperience',
  },
  {
    name: 'Roundwise Status',
    key: 'rounds',
  },
  {
    name: 'Address',
    key: 'address',
  },
  // {
  //   name: 'Rank',
  //   key: 'rank',
  // },
  {
    name: 'Stage',
    key: 'stage',
  },
  {
    name: 'Status',
    key: 'status',
  },
  {
    name: 'Uploaded CV',
    key: 'cvUrl',
  },
]

const mapExperienceArray = [
  {
    name: '10th',
    key: 'tenth',
  },
  {
    name: '12th',
    key: 'twelfth',
  },
  {
    name: 'UG',
    key: 'ug',
  },
  {
    name: 'PG',
    key: 'pg',
  },
  {
    name: 'Project',
    key: 'projects',
  },
  {
    name: 'Work Experience',
    key: 'workExperience',
  },
  {
    name: 'Roundwise Status',
    key: 'rounds',
  },
  {
    name: 'Address',
    key: 'address',
  },
  {
    name: 'Stage',
    key: 'stage',
  },
  {
    name: 'Status',
    key: 'status',
  },
  {
    name: 'Uploaded CV',
    key: 'cvUrl',
  },
]

const ApplicantExport = ({
  flag,
  setFlag,
  exportModalVisible,
  onHanldleCloseModal,
  exportCard,
  setExportCard,
  selectedRound,
  setSelectedFileType,
  selectedFileType,
  lastRound,
  singleRoleData,
}) => {
  const dispatch = useDispatch()
  const params = useParams()

  const baseMapArray =
    singleRoleData?.jobTypeLevels?.[0] === 'EXPERIENCED'
      ? mapExperienceArray?.filter(item => item !== null)
      : mapArray?.filter(item => item !== null)

  const filteredMapArray = singleRoleData?.applicationFormTemplate
    ? [{ name: 'Form Responses', key: 'formResponses' }, ...baseMapArray]
    : baseMapArray

  const onDownload = () => {
    dispatch(
      exportCandidate(
        params?.jobId,
        selectedRound === 'applications' && flag === false
          ? ''
          : selectedRound === 'offer' && flag === false
          ? 'OFFER'
          : flag === false
          ? selectedRound
          : '',
        selectedFileType,
        exportCard,
        flag ? 'GOOGLE' : 'EXCEL'
      )
    )
      .then(response => {
        if (response?.status >= 200 && response?.status <= 300) {
          if (flag) {
            window.open(response?.data?.data?.sheetUrl)
          } else {
            downloadAttachment(response?.data?.data?.url)
          }
          SuccessMessage('Candidate list downloaded successfully!')
          onHanldleCloseModal()
        } else {
          ErrorMessage(response?.response?.data?.message)
        }
      })
      .catch(error => {
        console.error('Error downloading:', error)
        ErrorMessage('An error occurred while downloading the candidate list.')
      })
  }

  const footer = () => {
    return (
      <FooterFlex center>
        <Button.Secondary
          text="Cancel"
          onClick={() => {
            onHanldleCloseModal()
          }}
        />
        <Button.Primary
          disabled={exportCard?.length === 0}
          onClick={onDownload}
          text={flag ? 'Export to google sheet' : 'Export to excel'}
        />
      </FooterFlex>
    )
  }

  const CardClick = cardId => {
    setExportCard(prev => {
      if (prev.includes(cardId)) {
        return prev.filter(id => id !== cardId)
      } else {
        return [...prev, cardId]
      }
    })
  }
  return (
    <Modal
      open={exportModalVisible}
      centered // This prop centers the modal vertically and horizontally
      footer={footer()} // Hide the default footer
      maskClosable={false} // Prevent closing the modal when clicking outside
      closable={false} // Hide the close button
      bodyStyle={{
        borderRadius: '20px',
        padding: '32px 20px 32px 20px',
        textAlign: 'center',
      }}
    >
      <Flex column>
        <div
          style={{
            fontWeight: 600,
            lineHeight: '25px',
            fontSize: '16px',
            color: '#010E30',
            marginBottom: '20px',
          }}
        >
          {flag ? 'Export titles to Google sheet' : 'Export titles to Excel'}
        </div>
        <br />

        <Row gutter={20} style={{ rowGap: '24px' }}>
          {filteredMapArray?.map((item, index) => (
            <Col key={item?.key} span={8}>
              <CardsFlex1
                column
                onClick={() => CardClick(item?.key)}
                isSelected={exportCard.includes(item?.key)}
                style={{
                  border: exportCard.includes(item?.key)
                    ? '1px solid #3249D7'
                    : `1px solid ${COLORS.GREY_T_90}`,
                }}
              >
                <CardText
                  style={{
                    color: exportCard.includes(item?.key)
                      ? '#3249D7'
                      : '#4B465C',
                  }}
                >
                  {item?.name}
                </CardText>
              </CardsFlex1>
            </Col>
          ))}
        </Row>
      </Flex>
    </Modal>
  )
}

export default ApplicantExport
